import moment from 'moment-timezone';
import { format, utcToZonedTime } from 'date-fns-tz';
import { ITimeZoneServer } from '@services/global-support/global-support.interface';

export const DEFAULT_TIME_ZONE = 'Central Time (US & Canada)';

export const TIME_ZONES = {
  'Eastern Time (US & Canada)': 'America/New_York',
  'Indiana (East)': 'America/Indiana/Indianapolis',
  'Central Time (US & Canada)': 'America/Chicago',
  'Saskatchewan': 'America/Regina',
  'Mountain Time (US & Canada)': 'America/Denver',
  'Arizona': 'America/Phoenix',
  'Pacific Time (US & Canada)': 'America/Los_Angeles',
  'Alaska': 'America/Juneau',
  'Atlantic Time (Canada)': 'America/Halifax',
  'Newfoundland': 'America/St_Johns',
  'Hawaii': 'Pacific/Honolulu',
  'Europe/London': 'Europe/London',
};

const TIME_ZONE_ABBREVIATIONS: Map<string, string> = new Map(
  Object.entries(TIME_ZONES)
    .map<Array<[string, string]>>(([label1, label2]: [string, string]) => {
      const abbr: string = moment().tz(label2).zoneAbbr() || moment().tz(label1).zoneAbbr();
      return [
        [label1, abbr],
        [label2, abbr],
      ];
    })
    .flat(),
);

export function getTimezoneAbbreviation(timezone: string): string {
  return TIME_ZONE_ABBREVIATIONS.get(timezone) || moment().tz(timezone).zoneAbbr() || timezone;
}

export const getTimezoneWithGMTOffset = (timezone: ITimeZoneServer): string => {
  const zonedDate = utcToZonedTime(new Date(), timezone.iana_identifier);
  const timeOffset = format(zonedDate, 'xxx', { timeZone: timezone.iana_identifier });
  const offset = `GMT${timeOffset}`;

  return `(${offset}) ${timezone.localized_standard_name}`;
};

export const getCorrectTimeZone = (timezone: string): string => {
  if (TIME_ZONES[timezone] !== undefined) {
    return TIME_ZONES[timezone];
  }
  return TIME_ZONES[DEFAULT_TIME_ZONE];
};